import {useTranslation} from "react-i18next";
import classNames from "classnames";
import React from "react";

import {Icon, Image} from "components/atoms";

import "./style.scss"

const ItemCard = (
    {
        img,
        name,
        price,
        rarity,
        onClick,
        isOwned,
        isActive,
        isRetired,
    }) => {
    const {t} = useTranslation()
    const nftCartStyle = classNames("item-card", rarity?.toLowerCase(), {"clickable": !!onClick})

    return (
        <div className="item-card-wrapper">
            <div className={nftCartStyle} onClick={onClick}>
                <div className="item-card_details">
                    <div className="item-card_details_active">{isActive ? t("active") : ""}</div>
                    <div className="item-card_details_owned">{isOwned ? t("owned") : ""}</div>
                </div>
                <div className="item-card_img">
                    <Image alt="cosmetic" src={img}/>
                    {isRetired && <div className="item-card_img_retired"><Icon name="fire"/> Retired</div>}
                </div>
                <div className="item-card_name-info">
                    <h5>{name}</h5>
                    {/*<span>{t("scarcityRank")}: #</span>*/}
                </div>
                <div className="item-card_price-info">
                    <div>{t("lowestPrice")}:</div>
                    {!!price ? <div><Icon name="kompete"/>{price}</div> : <div>N/A</div>}
                </div>
            </div>
        </div>
    )
}

export default ItemCard